<template>
    <div>
        <template v-if="!editMode">
            <a-icon
                icon="Hours"
                icon-class="text-primary cursor-pointer"
                @click.native="showEditOpeningHoursModal"
                v-tooltip="{
                    content: tooltipContent
                }"
            />
            <div class="mt-2 d-lg-none">
                <span class="mobile-head lg"
                    >Przynależność sklepu do sieci</span
                >
                <div>{{ networkName }}</div>
            </div>
        </template>
        <template v-else>
            <div>
                <span class="m-userStores__contactHeader d-lg-none"
                    >Godziny otwarcia</span
                >
                <div
                    class="d-flex flex-wrap flex-column pt-3 pt-lg-0 m-userStores__openingHoursColumn"
                >
                    <div
                        class="d-flex justify-content-between"
                        v-for="(dayValue, dayName) in openingHours(this.hours)"
                        :key="dayName"
                    >
                        {{ days[dayName] }}:
                        <span class="ml-3">{{ dayValue }}</span>
                    </div>
                    <the-btn
                        class="btn btn-primary btn-outline-custom mt-3"
                        icon="Edit"
                        icon-class="mr-2"
                        @click.native="showEditOpeningHoursModal"
                        >Edytuj godziny</the-btn
                    >
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import days from '@/dictionaries/days.json'

export default {
    data() {
        return {
            days
        }
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        hours: {
            type: Object,
            required: true
        },
        editLocationId: {
            type: Number
        },
        networkName: {
            type: String
        },
        tempData: {
            type: Object,
            required: false
        }
    },
    methods: {
        setOpeningHoursValue(value) {
            if (!value) {
                return '-'
            } else {
                switch (value) {
                case 'closed':
                    return 'Nieczynny'
                case '00:00-00:00':
                    return 'Całodobowy'
                default:
                    return value
                }
            }
        },
        showEditOpeningHoursModal(e) {
            e.preventDefault()
            this.$store.dispatch('openModal', {
                component: 'EditOpeningHours',
                args: {
                    hours: this.hours,
                    openingHours: this.openingHours(this.hours),
                    setOpeningHours: val => this.openingHours(val),
                    saveHoursChanges: val => this.saveHoursChanges(val)
                }
            })
        },
        openingHours(hours) {
            return {
                monday: this.setOpeningHoursValue(hours.opening_hours_monday),
                tuesday: this.setOpeningHoursValue(hours.opening_hours_tuesday),
                wednesday: this.setOpeningHoursValue(
                    hours.opening_hours_wednesday
                ),
                thursday: this.setOpeningHoursValue(
                    hours.opening_hours_thursday
                ),
                friday: this.setOpeningHoursValue(hours.opening_hours_friday),
                saturday: this.setOpeningHoursValue(
                    hours.opening_hours_saturday
                ),
                sunday: this.setOpeningHoursValue(hours.opening_hours_sunday)
            }
        },
        saveHoursChanges(changedData) {
            const updatedOpeningHoursData = {
                ...this.tempData,
                ...changedData
            }
            this.$store.dispatch('saveLocationOpeningHours', {
                editLocationId: this.editLocationId,
                changedData: changedData,
                updatedOpeningHoursData
            })
        }
    },
    computed: {
        tooltipContent() {
            let html =
                '<div class="p-2 text-left d-flex justify-content-between flex-column">'
            Object.entries(this.openingHours(this.hours)).forEach(val => {
                html += `<div class="d-flex justify-content-between">${
                    days[val[0]]
                }: <span class="ml-3">${val[1]}</span></div>`
            })
            html += '</div'
            return html
        }
    }
}
</script>
